import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Store } from '@/shared/store';

export const useDAppConnection = () => {
    const dAppData = useSelector((state: Store) => ({
        ...(state.modals.modalProps as any),
        connectedDapp: state.wallets?.walletConnect?.connectedDapp?.name,
    }));

    return useMemo(() => dAppData, [dAppData]);
};
